<template>
  <list
    row-key="id"
    ref="list"
    unit="产能列表"
    :expand-all-row="true"
    :page="page"
    :show-query="true"
    :query-params="params"
    :get-data-func="api.getCapacityList"
    urlHash="production/clothmanagement/capacity/capacityList"
    :queryParamsAppend="tempParams"
    :orderParamsAppend="orderParamsAppend"
  >
    <template slot="toolbar-right">
      <slot name="toolbar-right"></slot>
    </template>
    <template slot="table">
      <slot name="column"></slot>
    </template>
  </list>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
export default {
  mixins: [listMixin],
  components: {
    list
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      api: require('@/api/pr/plan').default,
      data: {},
      params: {},
      tempParams: {
        // SchedulingType: 1,
        // IsScheduling: true,
        HasMaintenance:true,        
        MaintenanceId: null
      },
      orderParamsAppend: {
        SortName: 'MaintenanceId,EndTime', //排序字段
        SortOrder: 'ASC,DESC' //排序顺序 降序：desc 升序：asc
      }
    }
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
